import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAllAgreementServicesforAgreement } from '../../api/Agreement';
import { faArrowUpRightFromSquare, faCheckCircle, faCircleXmark } from "@fortawesome/pro-regular-svg-icons";
import { useAuth } from "../../providers/AuthContext";

function AgreementServices({ agreement }) {
  const { getAccessToken } = useAuth();
  const [serviceList, setServiceList] = useState([]);
  const [categories, setCategories] = useState([]);

    useEffect(() => {
    if (!agreement?.agreementPublicId) return;

    const fetchServices = async () => {
      try {
        const accessToken = await getAccessToken();
        const agreementServices = await getAllAgreementServicesforAgreement(agreement.agreementPublicId, accessToken);
        const newCategories = [];
        for (let i = 0; i < agreementServices.length; i++) {
            const service = agreementServices[i];
            if (!newCategories.includes(service.category)) {
              newCategories.push(service.category);
            }
        }
        setCategories(newCategories);
        setServiceList(agreementServices);
      } catch (error) {
        console.error("Failed to fetch agreement services:", error);
      }
    };

    fetchServices();
  }, [agreement?.agreementPublicId]);

  return (
    <div className="px-8">
      <div className="flex flex-wrap gap-12">
        {categories.map((category) => {
          return ( 
            <div className="flex flex-col w-[30rem]" key={category}>
              <h5 className="text-lg font-bold mb-6">{category}</h5>
              {serviceList.filter(service => service.category == category).map(service => {
                return (
                  <React.Fragment key={service.name}>
              
                  <div className="flex flex-row items-center gap-6 py-2">
                    {service.isActiveForAgreement ? (
                      <div className="flex items-center justify-center h-[2rem] w-[2rem] rounded-full bg-secondary-400">
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="text-white w-[1rem] h-[1rem]"
                        />
                      </div>
                    ) : (
                      <div className="flex items-center justify-center h-[2rem] w-[2rem] rounded-full">
                        <FontAwesomeIcon
                          icon={faCircleXmark}
                          className="text-gray-300 w-[1rem] h-[1rem]"
                        />
                      </div>
                    )}
                    <div
                      className={`flex flex-col w-[18rem] ${service.isActiveForAgreement ? "" : "text-gray-300"
                        }`}
                    >
                      {service.websiteUrl ? (
                        <a
                          className={`inline-flex items-center gap-1 text-base hover:underline ${service.isActiveForAgreement ? "text-primary-500" : "text-primary-300"}`}
                          href={service.websiteUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {service.name}
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" aria-hidden="true" />
                        </a>
                      ) : (
                        <p className="text-base">{service.name}</p>
                      )}
                    </div>
                    
                  </div>
                  <p className="text-xs text-gray-500 pl-14">{service.comment}</p>

                </React.Fragment>
                )
              })}
            </div>
          )
        })}
       
      </div>
    </div>
  );
}

export default AgreementServices;